import React from 'react';
import { Navbar as BsNavbar, Nav, Container, Badge, Button, NavDropdown } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <BsNavbar bg="dark" variant="dark" expand="md" className="px-3">
      <BsNavbar.Brand as={NavLink} to="/dashboard">
        🎵 SpotiBot
      </BsNavbar.Brand>
      <BsNavbar.Toggle />
      <BsNavbar.Collapse>
        <Nav className="me-auto">
          <Nav.Link as={NavLink} to="/dashboard">Dashboard</Nav.Link>
          <Nav.Link as={NavLink} to="/queue">Queue</Nav.Link>
          <Nav.Link as={NavLink} to="/widget-generator">Widget</Nav.Link>
          <Nav.Link as={NavLink} to="/bot">Bot</Nav.Link>
          <Nav.Link as={NavLink} to="/settings/spotify">Spotify</Nav.Link>
          <Nav.Link as={NavLink} to="/settings/twitch">Twitch</Nav.Link>
          {user?.role === 'admin' && (
            <Nav.Link as={NavLink} to="/admin">
              Admin <Badge bg="danger">A</Badge>
            </Nav.Link>
          )}
        </Nav>
        <Nav>
          <NavDropdown
            title={<span className="text-light">{user?.username}</span>}
            id="user-dropdown"
            align="end"
            menuVariant="dark"
          >
            <NavDropdown.Item as={NavLink} to="/change-password">
              🔑 Passwort ändern
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </BsNavbar.Collapse>
    </BsNavbar>
  );
}
